import React from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useResponsive } from '@parsina/framework';
import VisitWeb from './Visit.web.jsx';
import VisitMobile from './Visit.mobile.jsx';
import { VISIT_TAB_IDS, DEFAULT_VISIT_TAB } from './Visit.shared.js';
import { useAppNavigate } from '../../hooks/useAppNavigate.js';

// جلسهٔ درمان — the visit workspace's ROUTING contract, kept out of the
// surfaces themselves (the shape PatientDetail/index.jsx established).
//
//  • The left column's tab is a `?tab=` QUERY parameter, so a refresh, the back
//    button and a shared link all restore the pane the dentist was working in.
//  • Switching tabs REPLACEs: the browser's history holds one entry per visit
//    rather than one per glance at a pane.
//  • 'diagnosis' is the default and is omitted from the URL.
//  • An unknown tab falls back to تشخیص instead of a blank pane, and THE SET
//    COMES FROM Visit.shared.js — the same list both surfaces render from.
//    That is the drift PatientDetail already paid for once, where 'chart' was
//    rendered as a tab while missing from the URL whitelist, so the odontogram
//    was unreachable by link and clicking the tab worked.
//  • Back goes back when there IS a history entry, and falls to امروز
//    otherwise: a visit is opened from the day sheet in every case the app
//    itself can produce, which is not true of a patient record.
//  • ≤768px gets a genuinely different surface, not this one reflowed. Both are
//    handed the SAME props, so the two can differ in every pixel and in nothing
//    else.

export const TABS = VISIT_TAB_IDS;
export const DEFAULT_TAB = DEFAULT_VISIT_TAB;

const VisitScreen = () => {
  const { appointmentId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const rrNavigate = useNavigate();
  const navigate = useAppNavigate();
  const { isMobile } = useResponsive();

  const raw = searchParams.get('tab');
  const tab = TABS.includes(raw) ? raw : DEFAULT_TAB;

  const setTab = React.useCallback(
    (next) => {
      const params = new URLSearchParams(searchParams);
      if (!next || next === DEFAULT_TAB) params.delete('tab');
      else params.set('tab', next);
      setSearchParams(params, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  const goBack = React.useCallback(() => {
    if (location.key && location.key !== 'default') rrNavigate(-1);
    else navigate('today');
  }, [location.key, rrNavigate, navigate]);

  const props = { appointmentId, tab, setTab, goBack };
  return isMobile ? <VisitMobile {...props} /> : <VisitWeb {...props} />;
};

export default VisitScreen;
